import { SocieteComposantRattachementSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteComposantRattachementModel: SelectorModel = {
  name: 'societeComposantRattachements',
  getSelector: SocieteComposantRattachementSelectors.selectAllSocieteComposantRattachementsDictionary,
  isReady: SocieteComposantRattachementSelectors.selectIsReadySocieteComposantRattachement
};
